export const rackFitsQuantity = (count, max, quantity) => {
  const used = Number(count);
  const capacity = Number(max);
  const incoming = Number(quantity);
  return Number.isSafeInteger(used) && used >= 0
    && Number.isSafeInteger(capacity) && capacity >= 0
    && Number.isSafeInteger(incoming) && incoming > 0
    && used + incoming <= capacity;
};
